import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { ReactComponent as ArrowL } from "../assets/img/arrow-left.svg";

import back1 from "../assets/img/back1.jpg";
import back2 from "../assets/img/back2.jpg";
import back3 from "../assets/img/back3.jpg";
import back4 from "../assets/img/back4.jpg";
import trans from "../assets/img/logo-trans.png";

import AuthService from "../services/auth.service";
import { useAuth } from "../contexts/AuthContext";
import tokenMonitor from "../services/tokenMonitor";
import { Label } from "reactstrap";

const required = (value) => {
  if (!value) {
    return (
      <div className="alert-info" role="alert">
        This field is required!
      </div>
    );
  }
};

const images = [back1, back2, back3, back4];

const NewLogin = () => {
    const { login } = useAuth();

  //this is the slider function
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isLogin, setIsLogin] = useState(true);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [vpassword, setVpassword] = useState("");
  const [emailSignIn, setEmailSignIn] = useState("");
  const [passwordSignIn, setPasswordSignIn] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [depositAmount, setDepositAmount] = useState("");
  const [duration, setDuration] = useState("");
  const [serviceType, setServiceType] = useState("");
  const [gender, setGender] = useState("");
  const [personalItem, setPersonalItem] = useState("");
  const [affiliation, setAffiliation] = useState("");
  const [successful, setSuccessful] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  let navigate = useNavigate();
  const formSignUp = useRef();
  const formSignIn = useRef();
  const checkBtn = useRef();

  const handleLoginClick = () => {
    setIsLogin(true);
    handleClearInputs();
  };

  const handleSignupClick = () => {
    setIsLogin(false);
    handleClearInputs();
  };

  const handleClearInputs = () => {
    setEmail("");
    setPassword("");
    setEmailSignIn("");
    setPasswordSignIn("");
    setFirstName("");
    setLastName("");
    setDateOfBirth("");
    setVpassword("");
    setMobileNumber("");
    setDepositAmount("");
    setDuration("");
    setServiceType("");
    setGender("");
    setAffiliation("");
    setServiceType("");
    setPersonalItem("");
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const onChangeFirstName = (e) => {
    setFirstName(e.target.value);
  };

  const onChangeLastName = (e) => {
    setLastName(e.target.value);
  };

  const onChangeDOB = (e) => {
    setDateOfBirth(e.target.value);
  };

  const onChangePassword = (e) => {
    setPassword(e.target.value);
  };

  const onChangeVpassword = (e) => {
    setVpassword(e.target.value);
  };

  const onChangeEmail = (e) => {
    setEmail(e.target.value);
  };
  const onChangeMobile = (e) => {
    setMobileNumber(e.target.value);
  };

  const onChangeGender = (e) => {
    setGender(e.target.value);
  };
  const onChangeAffiliation = (e) => {
    setAffiliation(e.target.value);
  };
  const onChangeDepositAmount = (e) => {
    setDepositAmount(e.target.value);
  };
  const onChangeDuration = (e) => {
    setDuration(e.target.value);
  };
  const onChangeServiceType = (e) => {
    setServiceType(e.target.value);
  };
  const onChangePersonalItem = (e) => {
    setPersonalItem(e.target.value);
  };
  const onChangeEmailSignIn = (e) => {
    setEmailSignIn(e.target.value);
  };
  const onChangePasswordSignIn = (e) => {
    setPasswordSignIn(e.target.value);
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  

  const handleLogin = async (e) => {
    e.preventDefault();

    setMessage("");
    setLoading(true);

    formSignIn.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      try {
        //navigate("/user/dashboard");

        // Login and get user data, including role
          const user = await login({
          emailSignIn: emailSignIn,
          passwordSignIn: passwordSignIn
        });

        // Restart token monitoring after successful login
        tokenMonitor.restart();

        // Check user role and redirect accordingly
        if (user.roles && user.roles.includes("ROLE_ADMIN")) {
          navigate("/admin/users");
        } else {
          navigate("/user/dashboard");
        }

      } catch (error) {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setLoading(false);
        setMessage(resMessage);
      }
    } else {
      setLoading(false);
    }
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(false);

    formSignUp.current.validateAll();

    if (password !== vpassword) {
      setMessage("Passwords do not match.");
      return;
    }
    try {
      // Create FormData object if we have an image
      let formData = new FormData();
      formData.append("email", email);
      formData.append("password", password);
      formData.append("firstName", firstName);
      formData.append("lastName", lastName);
      formData.append("dateOfBirth", dateOfBirth);
      formData.append("mobileNumber", mobileNumber);
      formData.append("gender", gender);
      formData.append("affiliation", affiliation);
      formData.append("depositAmount", depositAmount);
      formData.append("duration", duration);
      formData.append("serviceType", serviceType);
      formData.append("personalItem", personalItem);

      if (image) {
        formData.append("profileImage", image);
      }

      // Proceed with form submission
      if (checkBtn.current.context._errors.length === 0) {
        const response = await AuthService.register(formData);

        setMessage(response.data.message);
        setSuccessful(true);
        // Delay the navigation for 2 seconds
        setTimeout(() => {
          handleClearInputs();
          handleLoginClick();
        }, 2000);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      const resMessage =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      setLoading(false);
      setMessage(resMessage);
    }
  };

  return (
    <div className="homeSection">
      <div
        className="image-overlay"
        style={{
          backgroundImage: `url(${images[currentIndex]})`,
        }}
      ></div>
      <div className="homeSection-content">
        <div className="mobbiillee">
          <h1>Welcome to</h1>
          <h1 className="linear-color fordesk">American Massage Council</h1>
          <h1 className="linear-color formob">
            American <br />
            Massage Council
          </h1>
          <p>The most popular and trusted escrowservice</p>
        </div>
        <div className="wrapper-login">
          <div className="container">
            <div className="navv">
              <div
                className={`login login-edge ${
                  isLogin ? "active-modal active" : ""
                }`}
                onClick={handleLoginClick}
              >
                Sign In
              </div>
              <div
                className={`signup signup-edge ${
                  !isLogin ? "active-modal" : ""
                }`}
                onClick={handleSignupClick}
              >
                Sign Up
              </div>
            </div>

            {!isLogin ? (
              <Form
                onSubmit={handleSignUp}
                ref={formSignUp}
                className="signup-form"
              >
                <div className="inputs-1">
                  <label>Email</label>
                  <div className="input-feild-1">
                    <i className="input-icon fa-regular fa-envelope"></i>
                    <Input
                      type="text"
                      className="input-control"
                      name="email"
                      placeholder="Email"
                      value={email}
                      onChange={onChangeEmail}
                      validations={[required]}
                    />
                  </div>
                  <label>First Name</label>
                  <div className="input-feild-1">
                    <i class="input-icon fa-regular fa-user"></i>
                    <Input
                      type="text"
                      className="input-control"
                      name="firstName"
                      placeholder="First Name"
                      value={firstName}
                      onChange={onChangeFirstName}
                      validations={[required]}
                    />
                  </div>
                  <label>Last Name</label>
                  <div className="input-feild-1">
                    <i class="input-icon fa-regular fa-user"></i>
                    <Input
                      type="text"
                      className="input-control"
                      name="lastName"
                      placeholder="Last Name"
                      value={lastName}
                      onChange={onChangeLastName}
                      validations={[required]}
                    />
                  </div>
                  <label>Phone</label>
                  <div className="input-feild-1">
                    <i class="input-icon fa-solid fa-phone"></i>
                    <Input
                      type="text"
                      className="input-control"
                      name="Phone"
                      placeholder="Mobile Number..."
                      value={mobileNumber}
                      onChange={onChangeMobile}
                      validations={[required]}
                    />
                  </div>
                  <label>Gender</label>
                  <div className="input-feild-1">
                    <select
                      id="gender"
                      name="gender"
                      value={gender}
                      className="input-control"
                      onChange={onChangeGender}
                    >
                      <option value="" disabled hidden>
                        Select an option
                      </option>
                      <option value="male" className="jag-input">
                        Male
                      </option>
                      <option value="female" className="jag-input">
                        Female
                      </option>
                      <option value="Prefer not to say" className="jag-input">
                        Prefer not to say
                      </option>
                    </select>
                  </div>
                  <label>
                    Are you affiliated with any law enforcement agency
                  </label>
                  <div className="input-feild-1">
                    <select
                      id="affiliation"
                      name="affiliation"
                      value={affiliation}
                      className="input-control"
                      onChange={onChangeAffiliation}
                    >
                      <option value="" disabled hidden>
                        Select an option
                      </option>
                      <option value="Yes" className="jag-input">
                        Yes
                      </option>
                      <option value="No" className="jag-input">
                        No
                      </option>
                    </select>
                  </div>
                  <label>Date Of Birth</label>
                  <div className="input-feild-1">
                    <i class="input-icon fa-regular fa-calendar"></i>
                    <Input
                      type="date"
                      className="input-control"
                      name="dateOfBirth"
                      placeholder=""
                      value={dateOfBirth}
                      onChange={onChangeDOB}
                      validations={[required]}
                    />
                  </div>
                  <label>Enter Deposit Amount</label>
                  <div className="input-feild-1">
                    <Input
                      type="text"
                      className="input-control"
                      name="depositAmount"
                      placeholder="Enter Deposit Amount"
                      value={depositAmount}
                      onChange={onChangeDepositAmount}
                      validations={[required]}
                    />
                  </div>
                  <label>Duration </label>
                  <div className="input-feild-1">
                    <Input
                      type="text"
                      className="input-control"
                      name="duration"
                      placeholder="Enter Initial Meet Up Duration in minutes"
                      value={duration}
                      onChange={onChangeDuration}
                      validations={[required]}
                    />
                  </div>
                  <label>Service Type</label>
                  <div className="input-feild-1">
                    <select
                      id="serviceType"
                      name="serviceType"
                      value={serviceType}
                      className="input-control"
                      onChange={onChangeServiceType}
                    >
                      <option value="" disabled hidden>
                        Select an option
                      </option>
                      <option value="Massage" className="jag-input">
                        Massage
                      </option>
                      <option value="Escort" className="jag-input">
                        Escort
                      </option>
                      <option value="Full Service" className="jag-input">
                        Full Service
                      </option>
                    </select>
                  </div>
                  <label>Personal Items</label>
                  <div className="input-feild-1">
                    <select
                      id="personalItem"
                      name="personalItem"
                      value={personalItem}
                      className="input-control"
                      onChange={onChangePersonalItem}
                    >
                      <option value="" disabled hidden>
                        Select an option
                      </option>
                      <option value="Yes" className="jag-input">
                        Yes
                      </option>
                      <option value="No" className="jag-input">
                        No
                      </option>
                    </select>
                  </div>
                  {/* Add this after one of your existing fields */}
                  <label>Profile Picture</label>
                  <div className="input-feild-1">
                    {imagePreview ? (
                      <div style={{ marginBottom: "10px" }}>
                        <img
                          src={imagePreview}
                          alt="Preview"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                        />
                        <button
                          type="button"
                          onClick={() => {
                            setImage(null);
                            setImagePreview(null);
                          }}
                          style={{ marginLeft: "10px" }}
                        >
                          Remove
                        </button>
                      </div>
                    ) : null}

                    <div style={{ display: "flex", gap: "10px" }}>
                      <label
                        htmlFor="file-upload"
                        style={{
                          padding: "8px 12px",
                          backgroundColor: "#f0f0f0",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        Choose from Gallery
                      </label>
                      <input
                        id="file-upload"
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                        style={{ display: "none" }}
                      />

                     
                    </div>
                  </div>
                  <label>Password</label>
                  <div className="input-feild-1">
                    <i class="input-icon fa-solid fa-lock"></i>
                    <Input
                      type="password"
                      className="input-control"
                      name="password"
                      placeholder="Password"
                      value={password}
                      onChange={onChangePassword}
                      validations={[required]}
                    />
                  </div>
                  <label>Verify Password</label>
                  <div className="input-feild-1">
                    <i class="input-icon fa-solid fa-lock"></i>
                    <Input
                      type="password"
                      className="input-control"
                      name="vpassword"
                      placeholder="Password"
                      value={vpassword}
                      onChange={onChangeVpassword}
                      validations={[required]}
                    />
                  </div>
                  <div className="button-div-1">
                    <button className="loginbutton-1" disabled={loading}>
                      {loading && (
                        <span className="spinner-border spinner-border-sm"></span>
                      )}
                      <span>Sign Up</span>
                    </button>
                  </div>
                </div>

                {message && (
                  <div className="form-group">
                    <div className="alert-info" role="alert">
                      {message}
                    </div>
                  </div>
                )}
                <CheckButton style={{ display: "none" }} ref={checkBtn} />
              </Form>
            ) : (
              <Form
                onSubmit={handleLogin}
                ref={formSignIn}
                className="signup-form"
              >
                <div className="inputs-1">
                  <label>Email</label>
                  <div className="input-feild-1">
                    <i className="input-icon fa-regular fa-envelope"></i>
                    <Input
                      type="text"
                      className="input-control"
                      name="email"
                      placeholder="Email"
                      value={emailSignIn}
                      onChange={onChangeEmailSignIn}
                      validations={[required]}
                    />
                  </div>
                  <label>Password</label>
                  <div className="input-feild-1">
                    <i class="input-icon fa-solid fa-lock"></i>
                    <Input
                      type="password"
                      className="input-control"
                      name="password"
                      placeholder="Enter your password"
                      value={passwordSignIn}
                      onChange={onChangePasswordSignIn}
                      validations={[required]}
                    />
                  </div>
                </div>

                <div className="checkbox-1">
                  <input type="checkbox" />
                  <span className="box-1">Remember me</span>
                  <span className="box-1 forgot">Forgot Password?</span>
                </div>

                <div className="button-div-1">
                  <button className="loginbutton-1" disabled={loading}>
                    {loading && (
                      <span className="spinner-border spinner-border-sm"></span>
                    )}
                    <span>Sign In</span>
                  </button>
                </div>

                {message && (
                  <div className="form-group">
                    <div className="alert-info" role="alert">
                      {message}
                    </div>
                  </div>
                )}
                <CheckButton style={{ display: "none" }} ref={checkBtn} />
              </Form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewLogin;
